exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-default-page-tsx": () => import("./../../../src/pages/defaultPage.tsx" /* webpackChunkName: "component---src-pages-default-page-tsx" */),
  "component---src-pages-donate-page-tsx": () => import("./../../../src/pages/donatePage.tsx" /* webpackChunkName: "component---src-pages-donate-page-tsx" */),
  "component---src-pages-project-page-tsx": () => import("./../../../src/pages/projectPage.tsx" /* webpackChunkName: "component---src-pages-project-page-tsx" */)
}

